'use client';

import { FC, useEffect } from 'react';

export interface ScrollDataProps {
  data: unknown;
}

const ScrollToTop: FC<ScrollDataProps> = ({ data }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [data]);
  return null;
};

export default ScrollToTop;
